<!-- Main Content -->
<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-lg-10 col-md-12">
      <article>
        <!-- Header -->
        <div class="mb-4">
          <header class="d-flex flex-column align-items-start">
            <h2>Anmärkningar</h2>
            <a routerLink="/admin/create" class="btn btn-primary mt-2">
              <span>+ Skapa ny anmärkning</span>
            </a>
          </header>
        </div>

        <!-- Filter Section -->
        <section aria-label="Anmärkningslista">
          <div>
            <div class="d-flex align-items-center mt-2 filter-container">
              <div class="flex-grow-1 me-2 search-container">
                <mat-form-field appearance="fill" class="search-query">
                  <mat-label>Sök anmärkningar i listan</mat-label>
                  <input
                    matInput
                    #searchQuery
                    name="query"
                    (input)="setSearchQuery(searchQuery.value)"
                    id="traingrid-query"
                    placeholder="Sök anmärkningar i listan"
                    />
                  </mat-form-field>
                </div>
                <mat-form-field>
                  <mat-label>Sortera efter</mat-label>
                  <mat-select [value]="sortKey" (selectionChange)="setSortKey($event.value)" panelClass="mat-mdc-form-field-appearance-fill">
                    <mat-option value="updatedAt">Senast ändrad</mat-option>
                    <mat-option value="name">Bokstavsordning (A-Ö)</mat-option>
                    <mat-option value="suffixLetter">Suffix (A-Ö)</mat-option>
                    <mat-option value="active">Aktiv/Inaktiv</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Remarks Table -->
              <div>
                <table mat-table [dataSource]="filteredRemarksData" class="mat-elevation-z2 mt-3 py-3 mobile-table">
                  <!-- Suffix Column -->
                  <ng-container matColumnDef="suffix">
                    <mat-cell *matCellDef="let remark">
                      <div class="d-flex justify-content-center align-items-center">
                        <mat-chip-set>
                          <mat-chip>{{ remark.suffixLetter }}</mat-chip>
                        </mat-chip-set>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <!-- Name & Trains Column -->
                  <ng-container matColumnDef="nameAndTrains">
                    <mat-cell *matCellDef="let remark">
                      <div class="d-flex flex-column">
                        <a [routerLink]="['/admin/edit/', remark.id]" class="mat-body-strong">
                          {{ remark.name }}
                        </a>
                        <div class="train-list-container mt-2">
                          <div class="train-list-truncate">
                            <span>Tåg: </span>
                            <span>
                              {{ remark.trainNumbers.slice(0, 8).join(", ") }}
                              @if (remark.trainNumbers.length > 8) {
                                ...
                              }
                            </span>
                            <span class="ms-2">({{ remark.trainNumbers.length }} st)</span>
                          </div>
                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <!-- Exceptions Column -->
                  <ng-container matColumnDef="exceptions">
                    <mat-cell *matCellDef="let remark">
                      <div class="d-flex flex-column align-items-center text-center">
                        <i>{{ remark.exceptions.length ? remark.exceptions.length + ' undantag' : 'Inga undantag' }}</i>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <!-- Status Column -->
                  <ng-container matColumnDef="status">
                    <mat-cell *matCellDef="let remark">
                      <div class="d-flex flex-column align-items-center text-center my-2">
                        <div class="d-flex align-items-baseline">
                          <div class="status-circle m-1" [ngClass]="{ 'status-circle--active': remark.active }"></div>
                          {{ remark.active ? 'Aktiv' : 'Inaktiv' }}
                        </div>
                        <small class="mt-2">
                          Senast ändrad <b>{{ remark.updatedAt | date: 'yyyy-MM-dd hh:mm' }}</b>
                        </small>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <!-- Actions Column -->
                  <ng-container matColumnDef="actions">
                    <mat-cell *matCellDef="let remark">
                      <button mat-icon-button color="warn" (click)="openDeleteModal(remark.id)">
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>

                  <mat-row *matRowDef="let row; columns: ['suffix', 'nameAndTrains', 'exceptions', 'status', 'actions']"/>
                </table>
              </div>
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>
